<template>
	<div class="viewport" ref="viewport" @keyup.esc="hideOverlay">
        <PageHeader theme="light" />
        <Slider :slides=slidesData :startSlide=startSlide />
        <Overlay />
        <footer id="page_footer">
            <div class="grid-container">
                <div class="grid-x grid-margin-x">
                    <router-link to="/about" class="cell auto shrink">О проекте</router-link>
                    <router-link to="/poll" class="cell auto shrink">Лучший кейс</router-link>
                    <router-link to="/cases/1" class="cell auto shrink small-offset-7">FB</router-link>
                    <router-link to="/cases/2" class="cell auto shrink">VK</router-link>
                    <router-link to="/cases/2" class="cell auto shrink">TW</router-link>
                </div>
            </div>
        </footer>
	</div>
</template>

<script>
    import Data from './db'
    import PageHeader from './components/PageHeader'
    import Overlay from './components/Overlay'
    import Slider from './views/Slider'
    
    export default {
        name: "App",
        components: { PageHeader, Slider, Overlay },
        data: () => ({
            startSlide:0, loaded:false, slidesData:Data
        }),
        created(){
            let self = this

            window.addEventListener('keyup', e => {
                if(e.keyCode == 27 &&
                    (
                    self.$route.name === 'cases' ||
                    self.$route.name === 'about' ||
                    self.$route.name === 'poll'
                    )
                ) self.hideOverlay()
            })

            if(self.$route.params.slideId) self.startSlide = parseInt(self.$route.params.slideId)
            if(self.$route.params.caseId) self.showCase(self.$route.params.caseId)
            if(self.$route.name === 'cases') self.showCase()
            if(self.$route.name === 'about') self.showAbout()
            if(self.$route.name === 'poll') self.showPoll()
            
            self.$root.$on('hideOverlay', data => self.$router.go(-1))
        },
        mounted(){},
        methods: {
            getData(url){
                return new Promise((resolve, reject) => {
                    console.log('fake data request delay to', url)
                    setTimeout(() => {
                        console.log('resolved')
                        resolve({})
                    }, parseInt(Math.random()*1000))
                })
            },
            showOverlay(type, content){
                this.$root.$emit('showOverlay', { type, content })
            },
            hideOverlay(){
                this.$root.$emit('hideOverlay')
            },
            showCase(caseId){
                let self = this
                self.getData(`/path-to-cases/${caseId}`).then(data => {
                    self.showOverlay('case', Data[1].article)
                })
            },
            showAbout(){
                let self = this
                self.getData('/path-to-about').then(data => self.showOverlay('about', data))
            },
            showPoll(){
                let self = this
                self.getData('/path-to-poll').then(data => self.showOverlay('poll', data))
            }
        },
        watch: {
            '$route'(to, from){
                if(to.name === 'cases') this.showCase(to.params.caseId)
                if(to.name === 'about') this.showAbout()
                if(to.name === 'poll') this.showPoll()
            }
        }
    }
</script>

<style lang="scss">
    .viewport {
        width:100%; height:100vh; margin:0 auto 0; position:relative;
    }

    #page_header, #page_footer { position:fixed; width:100%; z-index:1; color:#fff; font-weight:bold; font-family:$sans-serif; text-transform:uppercase; font-size:fsz(.85rem) }
    #page_footer { bottom:0 }

    #page_footer {
        padding-bottom:$space;
        a { color:#fff }
    }
</style>